<template>
  <v-container fluid class="pa-0" style="height: 100%">
    <v-card flat class="rounded-0">

      <v-container class="d-flex pl-2 pr-4 py-2">
        <v-row no-gutters>
          <v-col cols="auto">
            <v-btn color="close" class="mr-2" icon @click="close()">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="auto">
            <QButtonGroup v-model="jobStatusGroup" :list="jobStatusGroupList" :noempty="true" :edit="true"
              :color="'primary'" class="mx-2">
            </QButtonGroup>
          </v-col>
          <v-col :cols="0" class="mr-4">
            <v-text-field v-model="listfilter" single-line dense clearable hide-details
              :label="$t('servicesystem.common_objects.commonterms.filter')" />
          </v-col>
          <v-col cols="auto" v-if="newable" class="d-flex justify-end align-center">
            <v-btn @click="createnew()" small color="primary">
              <v-icon size="17" class="mr-1">mdi-plus</v-icon>{{ $t('servicesystem.common_objects.commonterms.new') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <QScroll :height="350" :list="filteredList" :loading="loading" :skeletonloading="true">

        <template slot="list-item" slot-scope="{ item }">
          <!--
          <v-list-item>
            <v-list-item-action class="ma-0">
              <v-container class="pa-0">
                <v-row no-gutters>
                  <v-col>
                    <v-icon>mdi-circle</v-icon>
                  </v-col>
                </v-row>
              </v-container>
            </v-list-item-action>-->
          <job-li :key="item.Id" :jobItem="item" :previewMode="true" :showStatus="true" :showDateStepper="true">
          </job-li>
          <!--</v-list-item>-->
        </template>

        <template slot="skeleton-loader">
          <v-skeleton-loader type="list-item-avatar" class="contact">
          </v-skeleton-loader>
        </template>

      </QScroll>
    </v-card>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import JobLi from "@/components/ListItems/JobListItem/JobListItem.vue";
import QScroll from "@/components/Sections/Containers/QScroll.vue";

export default {
  name: "CustomerJobList",
  props: {
    CustomerId: [String, Number],
  },
  components: {
    QScroll,
    JobLi,
  },
  mixins: [clientAPI],

  data: () => ({
    list: {
      UpcomingJobList: [],
      OpenJobList: [],
      ClosedJobList: [],
    },
    listfilter: null,
    loading: false,
    jobStatusGroup: "UpcomingJobList",
    jobStatusGroupList: [
      {
        Id: 1,
        value: "UpcomingJobList",
        icon: "mdi-briefcase-upload",
        text: "upcoming",
      },
      {
        Id: 1,
        value: "OpenJobList",
        icon: "mdi-briefcase-clock",
        text: "open",
      },
      {
        Id: 2,
        value: "ClosedJobList",
        icon: "mdi-archive",
        text: "closed",
      },
    ],
  }),

  mounted() {
    this.getAllCustomerJobs();
  },

  methods: {
    getAllCustomerJobs() {
      if (this.CustomerId) {
        this.loading = true;
        this.getJobsByCustomer(this.CustomerId)
          .then((response) => {
            //console.log("Job lists", response, " by customer id", this.CustomerId);
            this.list = response;
          })
          .catch((response) => {
            console.error("getAllCustomerJobs error", response);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },

    close() {
      this.$emit("Close");
    },

    createnew() {
      this.$emit("New");
    },
  },

  computed: {
    filteredList() {
      if (this.jobStatusGroup) {
        return this.list[this.jobStatusGroup];
        /*
        return this.list.filter((v) =>
          v && v.MetaString
            ? v.MetaString.toUpperCase().includes(this.listfilter.toUpperCase())
            : null
        );
        */
      } else {
        return this.list.UpcomingJobList;
      }
    },

    newable() {
      return false && !this.CustomerAddressReadonly && this.checkPermission("Actions", "createCustomerAddress");
    },
  },

  watch: {
    CustomerId: function () {
      this.getAllCustomerJobs();
    },
  },
};
</script>